













































import Vue from 'vue'
import GHeaderBackButton from '@/components/globals/GHeader/GHeaderBackButton.vue'

export default Vue.extend({
  components: {
    GHeaderBackButton,
  },
  props: {
    title: {
      type: String as () => string,
      required: true,
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasRightButton(): boolean {
      return Boolean(this.$slots.rightButton)
    },
  },
})
